import { render } from "./Prefs.vue?vue&type=template&id=54742e98&scoped=true&ts=true"
import script from "./Prefs.vue?vue&type=script&lang=ts"
export * from "./Prefs.vue?vue&type=script&lang=ts"

import "./Prefs.vue?vue&type=style&index=0&id=54742e98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54742e98"]])

export default __exports__